module.exports = __webpack_public_path__ + "img/zkzy-colour.ce340d46.png";